import React from "react";
import styles from "../styles/PageLayout.module.css";

export function PageControls({ children }) {
  if (!children) return null;
  return <div className={styles.pageControls}>{children}</div>;
}

export default PageControls;
